module.exports = __webpack_public_path__ + "static/apple-icon-180x180-7e90891b2ea08a139bf4d214bb40d87f.png";